// 表头
module.exports = {
  // 视图表名
  viewTableName: 'viewTableName',
  // 视图表描述
  viewTableDescription: 'viewTableDescription',
  // 原表版本
  originalVersion: 'originalVersion',
  // 视图版本
  viewVersion: 'viewVersion',
  // 报表名称
  reportName: 'reportName',
  // 编码
  coding: 'coding',
  // 查询SQL
  querySQL: 'querySQL',
  // 数据源
  dataSource: 'dataSource',
  // 操作
  operate: 'operate',
  // 表类型
  tableType: 'Table Type',
  // 表名
  tableName: 'Table Name',
  // 表描述
  tableDescription: 'Table Description',
  // 分组标题
  groupTitle: 'groupTitle',
  // 取值表达式
  valueExpression: 'valueExpression',
  // 查询模式
  queryMode: 'queryMode',
  // 是否显示
  isDisplay: 'isDisplay',
  // 字段文本
  fieldText: 'fieldText',
  // 按钮编码
  buttonCode: 'buttonCode',
  // 按钮名称
  buttonName: 'buttonName',
  // 按钮样式
  buttonStyle: 'buttonStyle',
  // 按钮类型
  buttonType: 'buttonType',
  // 排序
  sort: 'sort',
  // 按钮图标
  buttonIcon: 'buttonIcon',
  // 表达式
  expression: 'expression',
  // 按钮状态
  buttonState: 'buttonState',
  fieldName: 'fieldName',
  // 字段备注
  fieldRemark: 'fieldRemark',
  // 字段类型
  fieldType: 'fieldType',
  // 字段Href
  fieldHref: 'fieldHref',
  // 验证规则
  fieldRule: 'fieldRule',
  // 校验必填
  fieldCheck: 'fieldCheck',
  // 字典Table
  fieldDic: 'fieldDic',
  // 字典Code
  fieldDicCode: 'fieldDicCode',
  // 字典Text
  fieldDicCodeText: 'fieldDicCodeText',
  // 默认值
  defaultValue: 'defaultValue',
  // 控件类型
  controlType: 'controlType',
  // 索引名称
  indexName: 'indexName',
  // 索引栏位
  indexField: 'indexField',
  // 索引类型
  indexType: 'indexType',
  // 主表名
  mainTableName: 'mainTableName',
  // 主表字段
  mainTableFields: 'mainTableFields',
  // 主键
  primaryKey: 'primaryKey',
  // 允许空值
  allowNulls: 'allowNulls',
  // 字段长度
  fieldLength: 'fieldLength',
  // 小数点
  decimalPoint: 'decimalPoint',
  // 表单显示
  formDisplay: 'formDisplay',
  // 列表显示
  listDisplay: 'listDisplay',
  // 是否排序
  isSort: 'isSort',
  // 是否只读
  isReadOnly: 'isReadOnly',
  // 控件长度
  controlLength: 'controlLength',
  // 是否查询
  isSearch: 'isSearch',
  // 查询类型
  searchType: 'searchType',
  // 控件默认值
  controlDefaultValue: 'controlDefaultValue',
  // 扩展参数
  extendedParameter: 'extendedParameter',
  // 自定义转换器
  customConverter: 'customConverter',
  yonghumingcheng: 'usename',//用户名称
  kucunliang: 'Inventory', // 库存量
  businessPartners: 'Business partners', // 业务伙伴
  costItemCode: ' Cost Item Code', // 成本项编号
  costItemName: ' Cost Item Name', // 成本项名称
  documentNumber: 'Document Number', // 单据编号
  periodCode: 'Period Code',//期间代码
  demandDate: 'Demand date', // 需求日期
  serviceDepartmentOrFarm: 'Service Department or Farm', // 服务部或农场
  documentType: 'Document Type', // 单据类型
  requestedArrivalDate: 'Requested Arrival Date', // 要求到货日期
  createdBy: 'Created by', // 创建人
  updateBy: 'update By', // 修改人
  updateTime: 'update Time', // 修改时间
  documentStatus: 'Document Status', // 单据状态
  syncStatus: 'Sync Status', // 同步状态
  syncMessage: 'Sync Message', // 同步消息
  operation: 'Operation', // 操作
  materialCode: 'Material Code', // 物料编码
  materialName: 'Material name', // 物料名称
  manufacturer: 'Manufacturer', // 厂家
  specification: 'Specification', // 规格
  unit: 'Unit', // 单位
  quantity: 'Quantity', // 数量
  arrivalDate: 'Arrival Date', // 到货日期
  remarks: 'Remarks', // 备注
  documentDate: 'Date of document', // 单据日期
  sourceInformation: 'Source Information', // 来源信息
  batchNumber: 'Batch number', // 批号
  supplierCode: 'Supplier Code', // 供应商编码
  supplierName: 'Supplier Name', // 供应商名称
  billingDate: 'Billing Date', // 单据日期
  billingStatus: 'Billing Status', // 单据类型
  unitName: 'Unit name', // 单位名称
  inboundQuantity: 'Inbound quantity', // 入库数量
  productionDate: 'Production Date', // 生产日期
  type: 'Type', // 类型
  purchaseContractNumber: 'Purchase Contract Number', // 采购合同号
  farm: 'Farm', // 农场
  notClearQuantity: 'Not clear Quantity', // 未清数量
  requestedDateOfShipment: 'Requested date of shipment', // 要求发货日期
  thirdPartySystemCode: 'Third party system code', // 第三方系统编码
  number: 'Number', // 编号
  weight: 'Weight', // 重量
  postingDate: 'Posting Date', // 过账日期
  customerCode: 'Customer Code', // 客户编码
  customerName: 'Customer Name', // 客户名称
  salesOrderNumber: 'Sales Order Number', // 销售订单号
  operator: 'Operator', // 操作人
  billLineNumber: 'Bill line number', // 单据行号
  salesType: 'Sales Type', // 销售类型
  averageWeight: 'Average weight(g)', // 均重(g)
  lineNumber: 'Line number', // 行号
  numberOfOrders: 'Number of orders', // 订单数
  outstanding: 'Outstanding', // 未清数
  warehouse: 'Warehouse', // 仓库
  warehouseLocation: 'Warehouse Location', // 库位
  expirationDate: 'Expiration date', // 有效期
  transferOutFarmServiceDepartment: 'Transfer out farm/service department', // 转出农场/服务部
  transferToFarmService: 'Transfer to Farm/Service', // 转入农场/服务部
  materialCodeMaterialNameBatchWarehouseLocation: 'Material Code|Material Name|Batch|Warehouse|Location', // 物料编码|物料名称|批次|仓库|库位
  transferOutWarehouse: 'Transfer out warehouse', // 转出仓库
  transferOutWarehousePosition: 'Transfer out warehouse position', // 转出库位
  transferToWarehouse: 'Transfer to warehouse', // 转入仓库
  transferToWarehousePosition: 'Transfer to warehouse position', // 转入库位
  transferOutWarehouseCode: 'Transfer out warehouse code', // 转出仓库编码
  transferOutWarehouseSpaceCode: 'Transfer out warehouse space code', // 转出库位编码
  building: 'Building', // 栋舍
  feedingLot: 'Feeding lot', // 饲养批次
  averageEggWeight: 'average Egg Weight', // 蛋均重（g）
  flockName: 'Flock name', // 批次名称
  placementAge: 'Placement age', // 入舍日龄
  generation: 'Generation', // 代次
  status: 'Status', // 状态
  breedingMethod: 'Breeding method', // 养殖方式
  creationTime: 'Creation time', // 创建时间
  gender: 'Gender', // 性别
  roundingNumber: 'Rounding Number', // 入舍数
  NumberOfStock: 'Number of stock', // 存栏数
  conclusion: 'Conclusion', // 结论
  dateOfAcceptance: 'Date of acceptance', // 验收日期
  receivingAndInspectionPersonnel: 'Receiving and inspection personnel', // 验收人员
  warehouseCode: 'Warehouse code', // 仓库编码
  warehouseName: 'Warehouse name', // 仓库名称
  roadDamage: 'Road Damage', // 路损
  quantityInStock: 'Quantity in stock', // 库存数量
  feedingQuantity: 'Feeding quantity', // 饲喂数量
  feedingMethod: 'Feeding method', // 饲喂方式
  feedingTime: 'Feeding time (minutes)', // 饲喂时间(分)
  quantityUsed: 'Quantity used', // 用量
  applicableScenario: 'Applicable scenario', // 适用场景
  genderBeforeConversion: 'Gender before conversion', // 转换前性别
  materialAbbreviation: 'Material abbreviation', // 物料简称
  startingAge: 'Starting Age', // 开始日龄
  theStartingAgeCannotBeGreaterThanTheEndingAge: 'The starting age cannot be greater than the ending age', // 起始日龄不能大于结束日龄
  endingAge: 'Ending age', // 结束日龄
  endingAgeCannotBeLessThanStartingAge: 'Ending age cannot be less than starting age', // 结束日龄不能小于起始日龄
  createdTime: 'Created Time', // 创建时间
  modifiedBy: 'Modified by', // 修改人
  modifiedAt: 'Modified at', // 修改时间
  harvestMaterial: 'Harvest material', // 出栏物料
  fromMaterial: 'from material', // from物料
  currentStock: 'Current stock', // 当前存栏
  transferOutFarm: 'Transfer out farm', // 转出农场
  transferOutOfTheBuilding: 'Transfer out of the building', // 转出栋舍
  transferToFarm: 'Transfer to farm', // 转入农场
  stock: 'Stock', // 存栏量
  dayAge: 'Day Age', // 日龄
  numberOfTransfer: 'Number of transfer', // 转出数量
  numberOfTransfersIn: 'Number of transfers in', // 转入数量
  transferOutBatch: 'Transfer out batch', // 转出批次
  quantityReceived: 'Quantity received', // 领用数量
  tibialLength: 'Tibial length (cm)', // 胫长(cm)
  numberOfWeighs: 'Number of weighs', // 称重只数
  version: 'Version', // 版本
  startDate: 'Start Date', // 开始日期
  endDate: 'End Date', // 结束日期
  dateOfCreation: 'Create Time', // 创建日期
  testResult: 'Test result', // 检测结果
  month: 'Month', // 月份
  billMaker: 'Bill maker', // 制单人
  numberOfPeopleOnTheRegister: 'Number of people on the register', // 在册人数
  numberOfOutsideAssociates: 'Number of outside associates', // 外协人数
  code: 'Code', // 编码
  name: 'Name', // 名称
  shortName: 'Short Name', // 简称
  farmerType: 'Farmer Type', // 养户类型
  whetherTheCompany: 'Whether the company (Y Yes N No)', // 是否公司(Y是N否)
  breedingScale: 'Breeding scale (only)', // 养殖规模(只）
  breederStatus: 'Breeder status', // 养户状态
  telephone: 'Telephone', // 电话
  contactPerson: 'Contact person', // 联系人
  affiliatedSupplierCode: 'Affiliated supplier code', // 关联供应商编码
  numberOfDeaths: 'Number of Deaths', // 死亡数量
  culls: 'Culls', // 淘汰数量
  sales: 'Sales', // 销售数量
  total: 'Total', // 合计
  partnerType: 'Partner Type', // 伙伴类型
  partnerGrouping: 'Partner Grouping', // 伙伴分组
  enterpriseType: 'Enterprise Type', // 企业类型
  country: 'Country', // 国家
  province: 'Province', // 省份
  cityPrefectureLevelCity: 'City/prefecture-level city', // 市/地级市
  countyDistrict: 'County/District', // 县/区
  legalPerson: 'Legal person', // 法人
  materialGroupCode: 'Material Group Code', // 物料组编码
  materialGroup: 'Material Group', // 物料组
  brand: 'Brand', // 品牌
  spectrum: 'Spectrum', // 谱系
  stockUnit: 'Stock unit', // 库存单位
  whetherValid: 'whether valid', // 是否有效
  description: 'Description', // 描述
  materialGroupClassification: 'Material group classification', // 物料组分类
  validity: 'Validity', // 有效性
  ERPInventoryLocation: 'ERP inventory location', // ERP库存地点
  warehouseType: 'Warehouse type', // 仓储类型
  warehouseIdentification: 'Warehouse Identification', // 仓库标识
  maximumCapacity: 'Maximum capacity(kg)', // 最大容量(kg)
  affiliatedWarehouse: 'Affiliated warehouse', // 所属仓库
  purchaseUnit: 'Purchase Unit', // 采购单位
  salesUnit: 'Sales unit', // 销售单位
  conversionRate: 'Conversion rate', // 换算率
  factoryCode: 'Factory Code', // 工厂编码
  batchManagement: 'Batch management', // 批次管理
  convertibleMaterialName: 'Convertible Material Name', // 可转换物料名称
  incubationAgeFrom: 'Incubation age from', // 孵化日龄从
  hatchingAgeTo: 'Hatching age to', // 孵化日龄到
  standardType: 'Standard Type', // 标准类型
  category: 'Category', // 品类
  enabledOrNot: 'Enabled or not', // 是否启用
  enable: 'Enable', // 启用
  disable: 'Disable', // 禁用
  lockedStatus: 'Locked status', // 锁定状态
  normal: 'Normal', // 正常
  locked: 'Locked', // 已锁定
  defaultVersion: 'Default version', // 默认版本
  weekAge: 'Week age', // 周龄
  eggMaterialCode: 'Egg material code', // 蛋品物料号
  eggMaterialName: 'Egg material name', // 蛋品物料名称
  HenFeedNumber: 'Hen feed number', // 母禽饲料号
  henFeedName: 'Hen feed name', // 母禽饲料名称
  standardGramOfHenFeed: 'standard gram of hen feed', // 母禽饲料只耗标准g
  maleFeedNumber: 'Male feed number', // 公禽饲料号
  maleFeedName: 'Male feed name', // 公鸡饲料名称
  standardGramOfMaleChickenFeed: 'Standard gram of male chicken feed', // 公鸡饲料只耗标准g
  vaccinationPeriod: 'Vaccination period', // 免疫周期
  startMonth: 'Start month', // 开始月份
  theStartMonthCannotBeGreaterThanTheEndMonth: 'The start month cannot be greater than the end month', // 开始月份不能大于结束月份
  endMonth: 'End month', // 结束月份
  theEndMonthCannotBeLessThanTheStartMonth: 'The end month cannot be less than the start month', // 结束月份不能小于开始月份
  target: 'Target', // 目标
  vaccineName: 'Vaccine name', // 疫苗名称
  vaccinationMethod: 'Vaccination method', // 接种方式
  dose: 'Dose', // 剂量
  item: 'Item', // 项目
  individualMinimum: 'Individual minimum', // 个体最小值
  individualMinimumCannotBeGreaterThanIndividualMaximum: 'Individual minimum cannot be greater than individual maximum', // 个体最小值不能大于个体最大值
  individualMaximum: 'Individual maximum', // 个体最大值
  individualMaximumValueCannotBeLessThanIndividualMinimumValue: 'Individual maximum value cannot be less than individual minimum value', // 个体最大值不能小于个体最小值
  minimumAverage: 'Minimum Average', // 最小平均值
  theMinimumMeanCannotBeGreaterThanTheMaximumMean: 'The minimum mean cannot be greater than the maximum mean', // 最小平均值不能大于最大平均值
  maximumMean: 'Maximum Mean', // 最大平均值
  theMaximumAverageCannotBeLessThanTheMinimumAverage: 'The maximum average cannot be less than the minimum average', // 最大平均值不能小于最小平均值
  Dispersion: 'Dispersion', // 离散度
  lightDuration: 'Light duration', // 光照时长
  minimumLightIntensity: 'Minimum light intensity', // 光照强度最小值
  maximumLightIntensity: 'Maximum light intensity', // 光照强度最大值
  temperatureMinimum: 'Temperature minimum', // 温度最小值
  temperatureMaximum: 'Temperature maximum', // 温度最大值
  highTemperatureAlarm: 'High temperature alarm', // 高温报警
  lowTemperatureAlarm: 'Low temperature alarm', // 低温报警
  humidityMinimum: 'Humidity Minimum', // 湿度最小值
  humidityMaximum: 'Humidity maximum', // 湿度最大值
  carbonDioxide: 'Carbon Dioxide', // 二氧化碳
  feedingAmount: 'Feeding amount (g/each/day)', // 饲喂量(克/只/天)
  livability: 'Livability(%)', // 成活率(%)
  bodyWeight: 'Body weight(g)', // 体重(克)
  weeklyEggProductionRate: 'Weekly egg production rate(%)', // 周产蛋率(%)
  htatchableEggRate: 'Htatchable Egg Rate(%)', // 种蛋合格率(%)
  layingRateOfHousedHens: 'Laying rate of housed hens(%)', // 入舍母禽产蛋率(%)
  eggWeight: 'Egg weight(g)', // 蛋重(克)
  hatchability: 'Hatchability (%)', // 种蛋孵化率(%)
  DOCLaidPerWeekByHousedHens: 'DOC laid per week by housed hens', // 入舍母禽周产雏数
  company: 'Company', // 公司
  feedingAmount: 'Feeding amount/g', // 饲喂量/g
  usage: 'Usage', // 用法
  grower: 'Grower', // 养户
  feedNumber: 'Feed number', // 饲料编号
  feedName: 'Feed name', // 饲料名称
  vaccineNumber: 'Vaccine number', // 疫苗编号
  vaccineName: 'Vaccine name', // 疫苗名称
  drugNumber: 'Drug number', // 药品编号
  drugName: 'Drug Name', // 药品名称
  incubationDate: 'Incubation date', // 上孵日期
  poultrySpeciesBatch: 'Poultry species batch', // 禽种批次
  incubationsNumber: 'Incubations number', // 上孵数量
  incubator: 'Incubator', // 孵化器
  dropDate: 'Drop date', // 落盘日期
  hatchingDate: 'Hatching date', // 出雏日期
  operationDate: 'Operation date', // 操作日期
  materialCodeBatchWarehouse: 'Material Code|Batch|Warehouse', // 物料编码|批次号|仓库
  hatchery: 'Hatchery', // 孵化场
  targetWarehouse: 'Target warehouse', // 目标仓库
  secondaryUOMQuantity: 'Secondary UOM quantity', // 辅计量数量
  inventoryNumber: 'Inventory number', // 库存数
  targetMaterialCode: 'Target material code', // 目标物料编码
  targetMaterialname: 'Target material name', // 目标物料名称
  incubationBatchNumber: 'Incubation batch number', // 孵化批号
  incubationDays: 'Incubation days', // 孵化天数
  hatchingNumber: 'Hatching number', // 在孵数
  hatcher: 'Hatcher', // 出雏器
  eggByProductCodeBatchNumber: 'Egg by-product code | batch number', // 蛋类副产品编码|批次号
  byProductDescription: 'By-product description', // 副产品描述
  immuneMode: 'Immune mode', // 免疫方式
  dictionaryName: 'Dictionary Name', // 字典名称
  dictionaryNumber: 'Dictionary number', // 字典编号
  dataValue: 'Data Value', // 数据值
  categoryName: 'Category name', // 分类名称
  categoryCode: 'Category code',// 分类编码
  userAccount: 'User account number', // 用户账号
  userName: 'User Name', // 用户姓名
  image: 'Image', //  头像
  birthday: 'Birthday', // 生日
  cellPhone: 'Cell phone', // 手机号码
  department: 'Department', // 部门
  roleCode: 'Role Code', // 角色编码
  roleName: 'Role Name', // 角色名称
  menuName: 'Menu name', // 菜单名称
  menuType: 'Menu Type', // 菜单类型
  icon: 'icon',//菜单图标
  frontComponents: 'Front-end components', // 前端组件
  menuPath: 'Menu Path', // 菜单路径
  sort: 'Sort by', // 排序
  ruleName: 'Rule name', // 规则名称
  ruleValue: 'Rule Value',// 规则值
  ruleField: 'Rule Field', // 规则字段
  eRPNumber: 'ERP Single number',//ERP单号
  storehouseType: 'Warehouse Type',//仓库类型
  farms: 'Farms', // 养殖场
  applicant: 'Applicant',//申请人
  contractNo: 'Contract No',//合同编号
  numberOfApplications: 'Number of applications',//申请数量
  theNumberOfShipments: 'The number of shipments',//发货数量
  receiptQuantity: 'Receipt quantity',//收货数量
  costPrice: 'Cost Price',//成本单价
  settlementUnitPrice: 'Settlement unit price',//结算单价
  farmingBatch: 'Farming Batch',//养殖批次
  plannedDateOfSeedling: 'Planned date of seedling',//计划进苗日期
  pleaseSelectBreedingBatch: 'Please select breeding batch',//请选择养殖批次
  growerName: 'Grower name',//养户名称
  technician: 'Technician', // 技术员
  contractID: 'Contract ID',//合同号
  settlementAmount: 'Settlement amount',//结算金额
  detailPrimaryKey: 'Detail primary key',//明细主键
  contractCode: 'Contract Code', // 合同编码
  cooperationMode: 'Cooperation mode',//合作模式
  dateOfSigning: 'Date of  signing',//签订日期
  effectiveDate: 'Effective Date', // 生效日期
  auditStatus: 'Audit Status', // 审核状态
  businessType: 'Business Type',//业务类型
  businessItem: 'Business Item',//业务项目
  expenseAmount: 'Expense amount',//费用金额
  auditStatus: 'Audit Status',//审核状态
  unitPrice: 'Unit Price',//单价
  materialCategory: 'Material category',//物料类别
  materialNumber: 'Material No.',//物料编号
  materialName: 'Material Name',//物料名
  specification: 'Specification',//规格
  job: 'job',//职务
  titleName: 'titleName', // 职务名称
  pleaseEnterTitleName: 'please Enter Title Name', // 请输入职务名称
  titleCode: 'titleCode', // 职务编码
  pleaseEnterTitleCode: 'please Enter Title Code', // 请输入职务编码
  titleRank: 'titleRank', // 职务职级
  pleaseChooseTitleRank: 'please Choose Title Rank', // 请选择职务职级
  unit: 'Unit',//单位
  amount: 'Amount',//金额
  bookkeepingDate: 'Bookkeeping date',//记账日期
  contracName: 'Contract name',//合同名称
  batchNumber: 'Batch Number',//批次编号
  batchName: 'Batch Name',//批次名称
  feedingCycle: 'Feeding cycle',//饲养周期
  plannedNumberOfChicks: 'Planned number of chicks',//计划入雏数量
  documentNo: 'Document No.',//单据编号
  batchNo: 'Batch No.',//养殖批次
  qtyRequested: 'Qty Requested',//申请数量
  plannedPlacementDate: 'Planned Placement Date',//计划进苗日期
  dateOfDemand: 'Date of demand',//需求日期
  receivedQty: 'Received Qty',//收货数量
  unitNo: 'Unit No.',//单位编号
  costUnitPrice: 'Cost Unit Price',//成本单价
  storageType: 'Storage type', // 入库类型
  serviceDepartment: 'Service Department', // 服务部
  date: 'Date',//日期
  breed: 'Breed', // 品种
  chickenPrice: 'Chicken Price',// 成鸡价格
  materialCommonName: 'Material Common Name',//物料通用名
  model: 'Model',//型号
  unitOfMeasurement: 'Unit of measurement',//计量单位
  validOrNot: 'Valid or not',//是否有效
  contracts: 'Contracts',//合同
  lastApprovalTime: 'Last approval time',//最后审批时间
  lastApprover: 'Last approver',//最后审批人
  reviewStatus: 'Review Status',//审核状态
  securityDepositOperation: 'Security Deposit Operation',//保证金操作
  businessDate: 'Business date',//业务日期
  operationTime: 'Operation time',//操作时间
  batch: 'Batch',//批次
  batchSize: 'Batch size',//批次规模
  placementQty: 'Placement Qty',//入雏数量
  currentStock: 'Current Stock',//当前存栏数
  reasonForApplication: 'Reason for application',//申请原因
  dateOfApplication: 'Date of application',//申请日期
  applicationType: 'Application Type',//申请类型
  totalAmount: 'Total amount',//金额合计
  accountDate: 'Account Date',//记账日期
  applicationInitiationDate: 'Application Initiation Date',//申请发起日期
  cooperationModel: 'Cooperation Model',//合作模式
  partyBDividendRatio: 'Party B Dividend Ratio',//乙方分红比例
  marketPrice: 'Market price',//市场价格
  exceedingPrice: 'Exceeding price',//超出价格
  stocker: 'Stocker',//放养员
  stockerInCharge: 'Stocker in charge',//放养负责人
  totalWeight: 'Total weight',//出栏总重量
  dividendAmount: 'Dividend amount',//分红金额
  accountOfTheBank: 'Account of the bank', // 开户行账户
  dividendPrice: 'Dividend Price',//分红价格
  contractName: 'Contract name',//合同名称
  cooperationMode: 'Cooperation mode',//合作模式
  contractType: 'Contract type',//合同类型
  dateOfContractSigning: 'Date of contract signing',//合同签订日期
  contractEffectiveDate: 'Contract effective date',//合同生效日期
  contractTerminationDate: 'Contract termination date',//合同终止日期
  placeOfSigning: 'Place of Signing',//签订地点
  sector: 'Sector',//部门
  enteredBy: 'Entered by',//录入人
  conversionRate: 'Conversion rate',//折本汇率
  fosterCareAdministrator: 'Foster Care Administrator',//养户管理员
  serviceGroup: 'Service Group',//服务组
  contractVersion: 'Contract Version',//合同版本
  breederAdministrator: 'Breeder Administrator',//养户管理员
  localCurrency: 'Local currency',//本位币
  currency: 'Currency',//币种
  industry: 'Industry',//行业
  partyB: 'Party B',//乙方养户
  partyA: 'Party A',//甲方公司
  applicationInitiationTime: 'Application Initiation Time',//申请发起时间
  mainUnitOfMeasurement: 'Main unit of measurement',//主计量单位
  fileCode: 'File Code',//档案编码
  fileDescription: 'File Description',//档案描述
  affiliateCategory: 'Affiliate Category',//关联类别
  costItemClassificationCode: 'Cost item classification code',//费用项分类编码
  costItemClassification: 'Cost item classification',//费用项分类
  costItems: 'Cost items',//成本项目
  diseaseFileCode: 'Disease file code',//疾病档案编码
  diseaseCategory: 'Disease category',//疾病类别
  diseaseFileDescription: 'Disease File Description',//疾病档案描述
  associatedDiseaseCategories: 'Associated Disease Categories',//关联疾病类别
  diseaseDescription: 'Disease description',//疾病说明
  symptomProfileCodes: 'Symptom Profile Codes',//症状档案编码
  symptomProfileName: 'Symptom Profile Name',//症状档案名称
  fileType: 'File Type',//档案类型
  symptomFileDescription: 'Symptom file description',//症状档案描述
  treatmentPlanName: 'Treatment plan name',//治疗方案名称
  treatmentPlanDescription: 'Treatment plan description',//治疗方案描述
  organsAnatomyFileCode: 'Organs anatomy file code',//脏器解剖档案编码
  anatomyFileName: 'Anatomy file name',//脏器解剖档案名称
  visceralAnatomyFileType: 'Visceral anatomy file type',//脏器解剖档案类型
  organDissectionClassification: 'Organ dissection classification',//脏器解剖分类
  inspectionSubcategoryCode: 'Inspection subcategory code',//巡检小类编码
  descriptionOfInspectionSubcategory: 'Description of inspection subcategory',//巡检小类描述
  inspectionCategory: 'Inspection category',//巡检大类
  inspectionSubCategoryNumber: 'Inspection sub-category number',//巡检小类编号
  nameOfInspectionCategory: 'Name of inspection category',//巡检小类名称
  recurringIndicatorFileNumber: 'Recurring indicator file number',//循环指标档案编号
  circularIndicatorFileName: 'Circular indicator file name',//循环指标档案名称
  breedingCategory: 'Breeding category',//饲养品类
  feedingStage: 'Feeding stage',//饲养阶段
  survivalRate: 'Survival rate',//成活率
  averageWeightOfAdultChickens: 'Average weight of adult poultry',//成鸡均重
  feedingAmount: 'Feeding amount',//喂料量
  realMeatRatio: 'Real meat ratio',//真实料肉比
  regularRatio: 'Regular ratio',//常规料肉比
  serviceCompanyGuaranteePoint: 'Service company guarantee point',//服务公司保本点
  seedlingPriceToMeatRatio: 'Seedling price to meat ratio',//种苗价肉比
  feedToMeatRatio: 'Feed to meat ratio',//饲料价肉比
  vaccinePriceToMeatRatio: 'Vaccine price to meat ratio',//疫苗价肉比
  healthCareMedicinePriceToMeatRatio: 'Health care medicine price to meat ratio',//保健药价肉比
  treatmentMedicinePriceToMeatRatio: 'Treatment medicine price to meat ratio',//治疗药价肉比
  priceToMeatRatioForPayingFarmers: 'Price to meat ratio for paying farmers',//支付养户成本价肉比
  fileName: 'File name',//档案名称
  standardCycleIndicatorNumber: 'Standard cycle indicator number',//标准循环指标编号
  standardCycleIndicatorName: 'Standard cycle indicator name',//标准循环指标名称
  chickenInspectionCode: 'Chicken Inspection Code',//鸡苗检查编码
  descriptionOfChickenInspection: 'Description of chicken inspection',//鸡苗检查描述
  addressOnly: 'Address', // 地址
  phoneNumber: 'Phone number', // 电话
  symptomCategory: 'Symptom Category',//症状类别
  descriptionOfTheOrganDissectionFile: 'Description of the organ dissection file',//脏器解剖档案描述
  associatedDiseaseDescription: 'Associated disease description',//关联疾病说明
  symptomProfile: 'Symptom Profile',//症状档案
  symptomName: 'Symptom name',//症状名称
  symptomDescription: 'Symptom Description',//症状说明
  visceralAnatomyProfile: 'Visceral anatomy profile',//脏器解剖档案
  organAnatomyName: 'Organ anatomy name',//脏器解剖名称
  organAnatomyDescription: 'Organ anatomy description',//脏器解剖说明
  treatmentPlanFile: 'Treatment plan file',//治疗方案档案
  treatmentProtocolName: 'Treatment protocol name',//治疗方案名称
  treatmentProtocolDescription: 'Treatment protocol description',//治疗方案说明
  symptomCategory: 'Symptom Category',//症状类别
  symptomProfileDescription: 'Symptom Profile Description',//症状档案描述
  treatmentPlanCode: 'Treatment Plan Code',//治疗方案编码
  treatmentPlanDescription: 'Treatment plan description',//治疗方案描述
  organsAnatomyCategory: 'Organs Anatomy Category',//脏器解剖类别
  descriptionOfTheOrganAutopsyFile: 'Description of the organ autopsy file',//脏器解剖档案描述
  planToRelease: 'Plan to release',//计划出栏
  averageWeight: 'average weight', // 均重
  auxiliaryQuantity: 'Auxiliary quantity',//辅助数量
  building: 'building', // 栋舍
  giveaway: 'Giveaway',//赠品
  operator: 'Operator', // 操作人
  roundingDate: 'Rounding date',//入舍日期
  species: 'Species',//品种
  settlementDate: 'Settlement date',//结算日期
  highestPrice: 'Highest Price',//最高价
  minimumPrice: 'Minimum price',//最低价
  numberOfSlaughtered: 'Number of slaughtered',//出栏羽数
  weightOfSlaughter: 'Weight of slaughter (kg)',//出栏重量(kg)
  averagePigeonWeight: 'Average pigeon weight(kg/feather)',//平均羽重(kg/羽)
  amountOfRecovery: 'Amount of recovery',//回收金额
  placementDate: 'Placement Date',//进鸡日期
  transferOutDepartment: 'Transfer out department',//转出部门
  transferToDepartment: 'Transfer to department',//转入部门
  materialSettlementPrice: 'Material settlement price',//物资结算价格
  lastApprover: 'Last approver',//最后审批人
  method: 'Method',//方式
  effectiveTime: 'Effective time',//生效时间
  productCostAccountCode: 'Prod. Cost Acc. Code', // 生产成本科目代码
  productCostAccountName: 'Prod. Cost Acc. Name', // 生产成本科目名称
  inventoryAccountCode: 'Inventory Acc. Code', // 库存科目代码
  inventoryAccountName: 'Inventory Acc. Name', // 库存科目名称
  salesCostAccountCode: 'Sales Cost Acc. Code', // 销售成本科目编号
  salesCostAccountName: 'Sales Cost Acc. Name', // 销售成本科目名称
  yonghumingcheng: 'User Name', // 用户名称
  ruleType: 'rule Type', // 规则类型
  RuleValueFormat: 'Rule Value Format', // 规则值格式
  fillRule: 'fill Rule', // 填充规则
  fillChar: 'fill Char', // 填充字符
  length: 'length', // 长度
  sex: 'sex' // 性别
}